module.exports = __webpack_public_path__ + "static/media/undraw_videographer_nnc7.8f4033dc.svg";